import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import { Message, Button, Confirm } from 'semantic-ui-react';

import withPagination from './WithPagination';
import LoadingDataEnhancer from './LoadingData';
import vinBlacklistsQuery from '../graphql/vinBlacklistsQuery';
import createVinBlacklistMutation from '../graphql/createVinBlacklistMutation';
import updateVinBlacklistMutation from '../graphql/updateVinBlacklistMutation';
import deleteVinBlacklistMutation from '../graphql/deleteVinBlacklistMutation';

import Search from '../views/Shared/Search';
import VinBlacklistsNew from '../views/VinBlacklists/New';
import VinBlacklistsEdit from '../views/VinBlacklists/Edit';
import VinBlacklistsList from '../views/VinBlacklists/List';
import { setSearch } from '../data/searchField/actions';
import { setPage } from '../data/page/actions';

class VinBlacklists extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVinBlacklist: null,
      isEditModalOpen: false,
      isDeleteConfirmationOpen: false,
      isNewModalOpen: false,
      newFormError: null,
      newFormSubmitting: null,
      flashMessage: null,
      editFormError: null,
      editFormSubmitting: null,
    };
  }

  onSearchSubmitHandler = event => {
    const {
      data,
      setSearchFields: setSearchFieldsProp,
      setPage: setPageProp,
    } = this.props;
    const { vin } = event.target;

    const variableArguments = {
      vin: vin.value || null,
    };

    data.refetch({
      ...variableArguments,
    });

    setSearchFieldsProp(variableArguments);
    setPageProp({});
  };

  onSelectVinBlacklist = (action, vinBlacklist) => {
    this.setState({
      selectedVinBlacklist: vinBlacklist,
    });

    switch (action) {
      case 'Edit':
        this.setState({
          isEditModalOpen: true,
        });
        break;
      case 'Delete':
        this.setState({
          isDeleteConfirmationOpen: true,
        });
        break;
      default:
        this.setState({
          selectedVinBlacklist: null,
        });
    }
  };

  openNewForm = () => {
    this.setState({ isNewModalOpen: true });
  };

  onNewFormCloseHandler = () => {
    this.setState({
      newFormError: null,
      newFormSubmitting: null,
      isNewModalOpen: false,
    });
  };

  onNewFormSubmitHandler = values => {
    const { createMutation, data } = this.props;
    const input = { vinBlacklist: { ...values } };
    this.setState({
      newFormSubmitting: true,
    });

    createMutation({
      variables: { input },
    })
      .then(({ data: responseData }) => {
        const { createVinBlacklist: { success, errors } } = responseData;
        if (success) {
          this.setState({
            newFormSubmitting: false,
            flashMessage: 'Successfully Created Vin Blacklist',
          });
          data.refetch();
          this.onNewFormCloseHandler();
        } else {
          this.setState({
            newFormSubmitting: false,
            newFormError: errors,
          });
        }
      })
      .catch(() => {
        this.setState({
          newFormSubmitting: false,
          newFormError: 'Error while creating vin blacklist',
        });
      });
  };

  onEditFormCloseHandler = () => {
    this.setState({
      editFormError: null,
      editFormSubmitting: null,
      isEditModalOpen: false,
    });
  };

  onEditFormSubmitHandler = values => {
    const { updateMutation, data, setPage: setPageProp } = this.props;
    const input = { vinBlacklist: { ...values } };
    this.setState({
      editFormSubmitting: true,
    });
    updateMutation({
      variables: { input },
    })
      .then(({ data: responseData }) => {
        const { updateVinBlacklist: { success, errors } } = responseData;
        if (success) {
          this.setState({
            editFormSubmitting: false,
            flashMessage: 'Successfully Updated vin blacklist',
          });
          data.refetch();
          setPageProp({});
          this.onEditFormCloseHandler();
        } else {
          this.setState({
            editFormSubmitting: false,
            editFormError: errors,
          });
        }
      })
      .catch(error => {
        this.setState({
          editFormSubmitting: false,
          editFormError: error,
        });
      });
  };

  handleDeleteConfirm = () => {
    const { deleteMutation, data, setPage: setPageProp } = this.props;
    const { selectedVinBlacklist: { id } } = this.state;
    const input = { vinBlacklistId: id };

    deleteMutation({
      variables: { input },
    })
      .then(({ data: responseData }) => {
        const { deleteVinBlacklist: { success } } = responseData;
        if (success) {
          this.setState({
            flashMessage: 'Successfully Deleted vin blacklist',
          });

          data.fetchMore({
            updateQuery: (
              previousResult,
              { fetchMoreResult }
            ) => {
              return fetchMoreResult;
            },
          });
          setPageProp({});
        } else {
          this.setState({
            flashMessage: 'Deleting vin blacklist not Success',
          });
        }
        this.setState({ isDeleteConfirmationOpen: false });
      })
      .catch(() => {
        this.setState({
          isDeleteConfirmationOpen: false,
          flashMessage: 'Deleting vin blacklist not Success',
        });
      });
  };

  handleDeleteCancel = () => {
    this.setState({ isDeleteConfirmationOpen: false });
  };

  render() {
    const { data: { vinBlacklists }, searchFields } = this.props;
    const {
      isNewModalOpen,
      newFormError,
      newFormSubmitting,
      isEditModalOpen,
      editFormError,
      editFormSubmitting,
      selectedVinBlacklist,
      flashMessage,
      isDeleteConfirmationOpen,
    } = this.state;

    return (
      <div>
        {flashMessage && (
          <Message
            onDismiss={this.handleDismiss}
            content={flashMessage}
            positive
          />
        )}
        <Button color='green' onClick={this.openNewForm} inverted>
          {' '}
          Create New Vin Blacklist
        </Button>
        <br />
        <br />
        <Search
          onSubmit={this.onSearchSubmitHandler}
          searchFields={searchFields}
          searchOptions={['vin']}
        />

        {isNewModalOpen && (
          <div>
            <VinBlacklistsNew
              isModalOpen={isNewModalOpen}
              onCloseHandler={this.onNewFormCloseHandler}
              onSubmitHandler={this.onNewFormSubmitHandler}
              error={newFormError}
              submitting={newFormSubmitting}
            />
          </div>
        )}

        {isEditModalOpen && (
          <div>
            <VinBlacklistsEdit
              isModalOpen={isEditModalOpen}
              onCloseHandler={this.onEditFormCloseHandler}
              onSubmitHandler={this.onEditFormSubmitHandler}
              error={editFormError}
              submitting={editFormSubmitting}
              vinBlacklist={selectedVinBlacklist}
            />
          </div>
        )}

        <VinBlacklistsList
          onSelectVinBlacklist={this.onSelectVinBlacklist}
          vinBlacklists={vinBlacklists}
        />
        <Confirm
          open={isDeleteConfirmationOpen}
          onCancel={this.handleDeleteCancel}
          onConfirm={this.handleDeleteConfirm}
        />
      </div>
    );
  }
}

VinBlacklists.propTypes = {
  data: PropTypes.shape({
    refetch: PropTypes.func.isRequired,
    fetchMore: PropTypes.func.isRequired,
    vinBlacklists: PropTypes.array,
  }).isRequired,
  setSearchFields: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  createMutation: PropTypes.func.isRequired,
  updateMutation: PropTypes.func.isRequired,
  deleteMutation: PropTypes.func.isRequired,
  searchFields: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
  setSearchFields: fields => {
    dispatch(setSearch(fields));
  },
  setPage: () => {
    dispatch(setPage());
  },
});

const mapStateToProps = state => {
  const { data: { searchFields } } = state;
  return {
    searchFields,
  };
};

export default compose(
  withRouter,
  withPagination(vinBlacklistsQuery, 'vinBlacklists'),
  graphql(createVinBlacklistMutation, { name: 'createMutation' }),
  graphql(updateVinBlacklistMutation, { name: 'updateMutation' }),
  graphql(deleteVinBlacklistMutation, { name: 'deleteMutation' }),
  LoadingDataEnhancer,
  connect(mapStateToProps, mapDispatchToProps)
)(VinBlacklists);
